import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Password = () => {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/login`, {
        email: form.email,
        password: form.password
      });

      // Save token to localStorage (or use a secure cookie)
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));

      // Redirect to dashboard or home page
      navigate('/qs-academy/guest/'); 
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className='w-full'>
      <form onSubmit={handleSubmit} className='w-full flex flex-col gap-2'>
        <span className='text-base font-bold text-[#abc7b9]'>Email Address</span>
        <input
          type="email"
          name="email"
          placeholder='Enter your email'
          value={form.email}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        <span className='text-base font-bold text-[#abc7b9]'>Password</span>
        <input
          type="password"
          name="password"
          placeholder='Password'
          value={form.password}
          onChange={handleChange}
          className='w-full border border-[#22BEFF33] outline-0 bg-[#143E55] text-[#abc7b9] p-3 px-4 rounded-md'
        />

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

        <button type="submit" className='w-full bg-[#22BEFF] p-3 mt-4 rounded-md cursor-pointer text-sm font-bold'>
          Sign in
        </button>

        <p className='mt-4 text-base font-medium text-[#abc7b9] text-center'>
          Don’t have an account yet? <Link to="/signup" className='text-[#22BEFF]'>Sign up</Link>
        </p>
      </form>
    </div>
  );
};

export default Password;
